import React from 'react'
import Arrow from '../../assets/icons/icon-arrow-up.svg'
import { Suspense, useEffect, useState } from 'react'
import clsx from 'clsx'
import { isValidStr } from '../../common_functions'
import SkeletonLoading from '../common/SkeletonLoading'
import enterpriseApi from '../../store/reducers/enterprise/enterpriseApi'

interface EnterpriseDetailCard {
  EnterpriseId: string
}

export default function Location({ EnterpriseId }: EnterpriseDetailCard) {
  const [hiddenContent, setHiddenContent] = useState(true)
  const { data, isError, isSuccess, isLoading } = enterpriseApi.useGetEnterpriseAddressByIdQuery(
    EnterpriseId ?? ''
  )

  const extractIframeSrc = (html: string): string => {
    const parser = new DOMParser()
    const doc = parser.parseFromString(html, 'text/html')
    const iframe = doc.querySelector('iframe')
    return iframe?.getAttribute('src') ?? ''
  }

  return (
    <>
      {isLoading && <SkeletonLoading height={150} />}
      {isSuccess && isValidStr(data?.Data.GoogleMap) ? (
        <>
          <section className="border border-gray-200 rounded-xl p-4" id="navInternEnterpriseLocation">
            <h3 className='text-lg text-[#4D4D4D] fw-normal mb-0'>Localização</h3>
            <p className='text-lg fw-bold text-center my-4'>{data?.Data.Location}</p>
            <div>
              <iframe
                src={extractIframeSrc(data?.Data.GoogleMap)}
                width="100%"
                className="w-full aspect-[15/11]"
              ></iframe>
            </div>
          </section>
        </>
      ) : (
        <></>
      )}
    </>
  )
}
